import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./trainers.css";
import trainerImg from "../../assets/otherimages/ourtraining.jpg";

function Trainers() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="trainers-section">
      <div className="container">

        <section>
          <div className="headlines-for-all" data-aos="fade-up">
            <h4>
              <span>Our </span> Trainers
            </h4>
          </div>
        </section>

        <div className="trainers-content">

          {/* Left text area */}
          <div className="trainers-text">
            <p data-aos="fade-up" data-aos-delay="100">
              At <strong><span className="fazo-fazo"> Fazo Academy </span></strong>, we are committed to delivering a{" "}
              <strong>comprehensive blend of theoretical knowledge and practical skills</strong> in Software Testing through our expertise in{" "}
              <strong>industry-focused training</strong>.
            </p>

            <p data-aos="fade-up" data-aos-delay="200">
              Our <strong>experienced Software Testing instructors</strong> specialize in{" "}
              <strong>manual and automated testing</strong> techniques, ensuring students develop{" "}
              <strong>real-world testing expertise</strong>.
            </p>

            <p data-aos="fade-up" data-aos-delay="300">
              Students gain hands-on experience with{" "}
              <strong>various testing methodologies</strong>, including{" "}
              <strong>Functional Testing, Regression Testing, Performance Testing, and Security Testing.</strong>
            </p>

            <p data-aos="fade-up" data-aos-delay="400">
              Our <strong>specialized training programs</strong> cover industry-leading tools like{" "}
              <strong>Selenium, JIRA, TestNG, JMeter, and Postman</strong>, enabling students to become proficient in{" "}
              <strong>test automation and software quality assurance</strong>.
            </p>

            <p data-aos="fade-up" data-aos-delay="500">
              Our <strong>dedicated Software Testing trainer</strong> designs personalized training modules that include{" "}
              <strong>real-time projects, test case creation, defect tracking, and interview preparation</strong>{" "}
              through mock testing scenarios.
            </p>
          </div>

          {/* Right image */}
          <div className="trainers-image">
            <img
              src={trainerImg}
              alt="Trainers"
              data-aos="zoom-in"
              data-aos-delay="300"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Trainers;
